import React from 'react';
import './Hero.css';
import { useCounter } from '../../hooks/useScrollAnimations';

const Hero = () => {
  const catRef = useCounter(15);
  const ipRef = useCounter(66);
  const supportRef = useCounter(24);
  const safetyRef = useCounter(100);

  return (
    <section className="hero-section" id="home">
      
      {/* ONE STATIC BACKGROUND IMAGE */}
      <div 
        className="prlx-bg" 
        style={{ backgroundImage: `url('/assets/images/The-first-Digital-Native-Factory-SNC.png')` }}
      ></div>
      
      {/* MORE TRANSPARENT BLUE OVERLAY */}
      <div className="prlx-overlay light-overlay"></div>
      <div className="prlx-overlay-gold"></div>
      
      <div className="hero-content" style={{ width: '100%' }}>
        <div className="hero-inner">
          <div className="hero-text-col">
            <div className="hero-eyebrow">Premier Industrial Engineering Solutions</div>
            <h1 className="hero-title">
              Advanced Control,<br /><em>Instrumentation</em><br />& Communication
            </h1>
            <p className="hero-sub">Profibercom delivers state-of-the-art integrated systems that prioritize safety, efficiency, and uninterrupted connectivity across mining, manufacturing, and heavy industry across Africa.</p>
            <div className="hero-btns">
              <a href="#products" className="btn-gold">Explore Products</a>
              <a href="#contact" className="btn-ghost">Get a Quote</a>
            </div>
            
            <div className="hero-stats">
              <div className="hero-stat">
                <div className="hero-stat-num"><span ref={catRef}>0</span>+</div>
                <div className="hero-stat-lbl">Product Categories</div>
              </div>
              <div className="hero-stat">
                <div className="hero-stat-num">IP<span ref={ipRef}>0</span></div>
                <div className="hero-stat-lbl">Rated Enclosures</div>
              </div>
              <div className="hero-stat">
                <div className="hero-stat-num"><span ref={supportRef}>0</span>/7</div>
                <div className="hero-stat-lbl">Technical Support</div>
              </div>
              <div className="hero-stat">
                <div className="hero-stat-num"><span ref={safetyRef}>0</span>%</div>
                <div className="hero-stat-lbl">Safety Focused</div>
              </div>
            </div>
          </div>
          
          <div className="hero-visual">
            <div className="hero-card">
              <img src="/assets/images/dd64f983-29bb-43b5-9ea1-93a5c07d3c43-Smart-Monitor-for-Asset-eXcellence-is1357436548-500x500.jpeg" alt="Control System" />
            </div>
            <div className="hero-badge"><strong>Zero-Harm</strong>Engineering</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;